/**
 * Reserve une page aux administrateurs.
 *
 * S'appuie sur la session chargee par `auth.global.ts`, qui s'execute avant
 * les middlewares de page : au moment ou celui-ci s'execute, `store.user` est
 * renseigne.
 */
export default defineNuxtRouteMiddleware(() => {
  const { isAdmin } = useAuthorization()

  if (!isAdmin.value) {
    throw createError({
      statusCode: 403,
      message: 'Accès réservé aux administrateurs',
    })
  }
})
